
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/login_form",
      function () {
        return require("private-next-pages/login_form.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/login_form"])
      });
    }
  